import React from 'react';
import {Link} from 'react-router-dom';
import './profile.css';
import AnalyticsImage from './analytics.jpeg';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faArrowLeft} from '@fortawesome/free-solid-svg-icons';

function Profile({logout}) {

  const logoutHanlder = () => {
    logout();
    window.open("/","_self");
  }
  return (
      <div >
          <h3 className='text-center'>Welcome to SPS Land Promoter's Admin Panel </h3>
       <div style={{display:'flex', justifyContent:'flex-end'}}>
         <button
         onClick={logoutHanlder} className="logout_button" >Logout</button>
       </div>
         
           {/* <img src={AnalyticsImage} className="analytics_image" /> */}
            
    <div style={{display:'flex', justifyContent:'space-between'}}>

<div>
  <FontAwesomeIcon 
   icon={faArrowLeft} 
   onClick={()=> window.open("/","_self")}
   className="arrow_left_admin"/> <span style={{fontSize:'1.2rem', fontWeight:'bold', color:'darkgray'}}>Back to Home </span>  
</div>

</div>

     <div>
          <Link to="/admin-panel" className='admin_panle_link' >View dashboard</Link>
         </div>
         <div className='analytics_button_container'>
         <button style={{fontSize:'1.1rem'}} className="btn btn-sm btn-primary m-3 text-center " onClick={()=>window.open("https://analytics.google.com/analytics/web/?authuser=6#/p302918527/reports/reportinghub","_self")}>View Analytics</button>
         </div>
          </div>
  )
}

export default Profile